export enum PreprintSteps {
  TitleAndAbstract = 0,
  File,
  Metadata,
  AuthorAssertions,
  Supplements,
  Review,
}
